import React from "react";
import ReactPaginate from "react-paginate";

const CommonPagination = ({
  currentPage,
  totalPages,
  limit,
  onPageChange,
  onLimitChange,
  limitOptions = [5, 10, 15, 20, 50],
}) => {
  return (
    <div className="pagination-container d-flex align-items-center justify-content-between mt-3">

      <div className="Limit-Dropdown">
        <label className="fw-semibold me-2">Items per page:</label>
        <select
          value={limit}
          onChange={onLimitChange}
          className="form-select d-inline w-auto"
        >
          {limitOptions.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      </div>

      <ReactPaginate
        previousLabel="Previous"
        nextLabel="Next"
        pageCount={totalPages}
        onPageChange={onPageChange}
        forcePage={currentPage}
        containerClassName="pagination"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        activeClassName="active"
        breakLabel="..."
        breakClassName="page-item"
        breakLinkClassName="page-link"
        marginPagesDisplayed={1}
        pageRangeDisplayed={3}
        disabledClassName="disabled"
      />
    </div>
  );
};

export default CommonPagination;
